export { RangeControl } from './component';
export type {
	ControlledRangeValue,
	RangeControlProps,
	RangeMark,
	RangeMarks,
} from './types';
